import { gql } from '@apollo/client';

export const ASSIGN_JOB_OFFER_TO_USERS = gql`
    mutation ($jobOfferId: ID!, $assignees: [AssigneeInput!]!, $proId: ID) {
        assignJobOfferToUsers(jobOfferId: $jobOfferId, assignees: $assignees, proId: $proId) {
            _id
            assignees {
                _id
                assigneeType
                role
                assigneeDetails {
                    ... on OrganizationUser {
                        _id
                        firstName
                        lastName
                        file {
                            url
                        }
                    }
                    ... on Pro {
                        _id
                        commercialName
                        bossFirstname
                        bossLastname
                        bossPhoto
                    }
                }
            }
        }
    }
`;

export const ADD_JOB_OFFER_PRO = gql`
    mutation ($payload: JobOfferInput) {
        addJobOfferPro(jobInput: $payload) {
            _id
            jobNumber
            talentPlugUrl
        }
    }
`;

export const ADD_JOB_OFFER_UPERCUT = gql`
    mutation ($payload: JobOfferInput, $proId: ID) {
        addJobOfferUpercut(jobInput: $payload, proId: $proId) {
            _id
            jobNumber
            talentPlugUrl
        }
    }
`;

export const ADD_JOB_OFFER_DRAFT_PRO = gql`
    mutation ($payload: JobOfferInput) {
        addJobOfferDraftPro(jobInput: $payload) {
            _id
            jobNumber
            title
            status
        }
    }
`;

export const ADD_JOB_OFFER_DRAFT_UPERCUT = gql`
    mutation ($payload: JobOfferInput, $proId: ID) {
        addJobOfferDraftUpercut(jobInput: $payload, proId: $proId) {
            _id
            jobNumber
            title
            status
        }
    }
`;

export const GET_JOB_OFFER_DEACTIVATION_IMPACT = gql`
    query ($jobOfferId: ID!, $proId: ID) {
        getJobOfferDeactivationImpact(jobOfferId: $jobOfferId, proId: $proId) {
            total
            jobOfferTitle
            jobOfferNumber
            byStatus {
                status
                count
            }
        }
    }
`;

export const DEACTIVATE_JOB_OFFER_PRO = gql`
    mutation ($id: ID!) {
        deactivateJobOfferPro(_id: $id) {
            _id
        }
    }
`;
export const ACTIVATE_JOB_OFFER_PRO = gql`
    mutation ($id: ID!) {
        activateJobOfferPro(_id: $id) {
            _id
        }
    }
`;

export const PUBLISH_JOB_OFFER_DRAFT_PRO = gql`
    mutation PublishJobOfferDraftPro($id: ID!) {
        publishJobOfferDraftPro(_id: $id) {
            _id
            status
            jobNumber
        }
    }
`;

export const PUBLISH_JOB_OFFER_DRAFT_UPERCUT = gql`
    mutation PublishJobOfferDraftUpercut($id: ID!, $proId: ID!) {
        publishJobOfferDraftUpercut(_id: $id, proId: $proId) {
            _id
            status
            jobNumber
        }
    }
`;

export const UPDATE_JOB_OFFER_PRO = gql`
    mutation ($payload: JobOfferInput) {
        updateJobOfferPro(jobInput: $payload) {
            _id
            jobNumber
        }
    }
`;

export const UPDATE_JOB_OFFER_UPERCUT = gql`
    mutation ($payload: JobOfferInput) {
        updateJobOfferUpercut(jobInput: $payload) {
            _id
            jobNumber
        }
    }
`;

export const ADD_JOB_APPLICATION_TALENT = gql`
    mutation ($payload: JobApplicationInput) {
        addJobApplicationTalent(jobInput: $payload) {
            _id
        }
    }
`;

export const SEND_EMAIL_INVITATION_JOB_OFFER = gql`
    mutation ($jobNumbers: [String], $talentIds: [ID], $jobInput: BulkJobApplicationInput) {
        sendInvitationJobOffer(jobNumbers: $jobNumbers, talentIds: $talentIds, jobInput: $jobInput)
    }
`;

export const ADD_GUEST_JOB_APPLICATION = gql`
    mutation addGuestJobApplication($payload: InputJobApplication!) {
        addGuestJobApplication(payload: $payload) {
            _id
            jobNumber
            message
            status
            resume
            privateNote
            resolvedDate
            talentId
        }
    }
`;

export const GET_JOB_APPLICATION_NOTES = gql`
    query GetJobApplicationNotesUpercut($jobApplicationId: ID!) {
        getJobApplicationNotesUpercut(jobApplicationId: $jobApplicationId) {
            _id
            upercutId
            note
            title
            visibility
            createdAt
        }
    }
`;

export const CREATE_JOB_APPLICATION_NOTE = gql`
    mutation CreateJobApplicationNoteUpercut($jobApplicationId: ID!, $input: JobApplicationUpercutNoteInput!) {
        createJobApplicationNoteUpercut(jobApplicationId: $jobApplicationId, input: $input) {
            _id
            upercutId
            note
            title
            visibility
            createdAt
        }
    }
`;

export const UPDATE_JOB_APPLICATION_NOTE = gql`
    mutation UpdateJobApplicationNoteUpercut(
        $jobApplicationId: ID!
        $noteId: ID!
        $input: JobApplicationUpercutNoteInput!
    ) {
        updateJobApplicationNoteUpercut(jobApplicationId: $jobApplicationId, noteId: $noteId, input: $input) {
            _id
            upercutId
            note
            title
            visibility
            createdAt
        }
    }
`;

export const DELETE_JOB_APPLICATION_NOTE = gql`
    mutation DeleteJobApplicationNoteUpercut($jobApplicationId: ID!, $noteId: ID!) {
        deleteJobApplicationNoteUpercut(jobApplicationId: $jobApplicationId, noteId: $noteId)
    }
`;

export const UPDATE_JOB_APPLICATION_RATING = gql`
    mutation UpdateJobApplicationRatingUpercut($jobApplicationId: ID!, $rating: Float!) {
        updateJobApplicationRatingUpercut(jobApplicationId: $jobApplicationId, rating: $rating) {
            _id
            upercutAverageRating
            upercutRatings {
                upercutId
                rating
                createdAt
            }
        }
    }
`;

export const UPDATE_JOB_APPLICATION_STATUS = gql`
    mutation UpdateJobApplicationStatus($_id: ID!, $status: String!, $subStatus: String!) {
        updateJobApplication(_id: $_id, status: $status, subStatus: $subStatus) {
            _id
            status
            subStatus
        }
    }
`;

export const UPDATE_APPLICATION_PREMIUM_STATUS_UPERCUT = gql`
    mutation UpdateApplicationPremiumStatusUpercut(
        $jobApplicationId: ID!
        $premiumStatus: String!
        $premiumSubStatus: String!
        $interviewScheduledAt: String
        $skipN8n: Boolean
    ) {
        updateApplicationPremiumStatusUpercut(
            jobApplicationId: $jobApplicationId
            premiumStatus: $premiumStatus
            premiumSubStatus: $premiumSubStatus
            interviewScheduledAt: $interviewScheduledAt
            skipN8n: $skipN8n
        ) {
            _id
            premiumStatus
            premiumSubStatus
            interviewScheduledAt
            questionnaireId
            questionnaireSentAt
            staleness {
                level
                lastUpdateDate
                daysSinceUpdate
            }
        }
    }
`;

export const SCORE_JOB_APPLICATION = gql`
    mutation ScoreJobApplication($jobApplicationId: ID!) {
        scoreJobApplication(jobApplicationId: $jobApplicationId) {
            _id
            resumeScore
            resumeScoreError
            resumeExplainer
            scoringStatus
        }
    }
`;

export const GET_JOB_APPLICATION_SCORING = gql`
    query GetJobApplicationScoring($id: ID!) {
        getJobApplication(id: $id) {
            _id
            resumeScore
            resumeScoreError
            resumeExplainer
            scoringStatus
        }
    }
`;

export const BATCH_RETRY_SCORE_JOB_APPLICATIONS = gql`
    mutation BatchRetryScoreJobApplications($limit: Int) {
        batchRetryScoreJobApplications(limit: $limit) {
            trimojiTriggeredCount
            directRetryCount
            totalFound
        }
    }
`;

export const CLEAR_JOB_APPLICATIONS_CACHE = gql`
    mutation ClearJobApplicationsCache($proId: String) {
        clearJobApplicationsCache(proId: $proId)
    }
`;

// note refactor this into fragment

// note refactor this into fragment
export const JOB_FRAGMENT = gql`
    fragment jobFragment on JobOffer {
        _id
        active
        status
        title
        customFields
        offre_cachee
        publicLink
        city
        featureId
        address
        brandId
        showPhotos
        showVideo
        brand {
            brandName
            description
            sector {
                sectorName
                pronounWithSector
            }
            brandLogo {
                _id
                url
            }
            brandVideo {
                _id
                url
            }
            brandVideos {
                _id
                url
            }
            brandPhotos {
                _id
                url
            }
            brandBanner {
                _id
                url
            }
        }
        postalCode
        publishDate
        createdDate
        enablePublishDate
        expiredDate
        currentPlan
        jobNumber
        specialties {
            specialtyName
        }
        description {
            qualifications
            missions
            advantages
            listAdvantages
        }
        position {
            companyName
            experience
            allowFreshGrad
            hasTeam
            place
            professions
            teamNumber
            numberOfPositions
        }
        candidate {
            softSkills
            softSkillIds
            degree
            specialties
            languages {
                languageId
                levelId
                language {
                    _id
                    code
                    original_letter
                    name
                }
                mandatory
                levelLanguage {
                    _id
                    level
                    score
                }
            }
        }
        contract {
            benefits
            rtt {
                days
                isActive
            }
            bonus {
                max
                type
            }
            commission {
                amount
                origin
            }
            rateType
            isAnnualSalary
            showSalary
            remuneration {
                min
                max
            }
            contractType
            dayOff {
                number
                unit
            }
            dayPerWeek
            endDate
            guaranteedSalary {
                min
                max
                type
            }
            hourPerWeek
            monthPerYear
            startDate
            status
            contractAsset
            showBonus
        }
        recruitment {
            attempt
            method
            duration
            mode
            place
            quickResponse
            premiumFeatures
            steps
            interviewDate {
                date
                time {
                    start
                    end
                }
            }
        }
        assignees {
            _id
            assigneeType
            role
            assignedAt
            assigneeDetails {
                ... on OrganizationUser {
                    _id
                    color
                    email
                    firstName
                    lastName
                    role
                    file {
                        _id
                        name
                        url
                    }
                }
                ... on Pro {
                    _id
                    email
                    bossFirstname
                    bossLastname
                    bossPhoto
                    commercialName
                    role
                }
            }
            assignedBy {
                ... on OrganizationUser {
                    _id
                    firstName
                    lastName
                }
                ... on Pro {
                    _id
                    bossFirstname
                    bossLastname
                    commercialName
                }
            }
        }
        upercutAssignees {
            _id
            assignedAt
            firstName
            lastName
            email
            color
        }
        pro {
            _id
            publicProfile
            description
            experience
            city
            photo
            photos
            logo
            video {
                _id
                url
            }
            principalProfession {
                professionName
            }
            sector {
                _id
                sectorName
                pronounWithSector
            }
            commercialName
            createdDate
        }
        application {
            createdDate
            talentId
            status
            message
        }
        views
        profileCompletionRate
        completedProfileSections
        companyDescription
        jobRequirements
        personiId
        questionnaireIds
        jobApplicationsStats {
            _id
            count
        }
    }
`;

export const GET_JOB_OFFER_UPERCUT = gql`
    query ($_id: ID, $jobNumber: String, $showInactive: Boolean) {
        getJobOfferUpercut(_id: $_id, jobNumber: $jobNumber, showInactive: $showInactive) {
            ...jobFragment
        }
    }
    ${JOB_FRAGMENT}
`;

export const GET_JOB_OFFER_PRO = gql`
    query ($_id: ID, $jobNumber: String) {
        getJobOfferPro(_id: $_id, jobNumber: $jobNumber) {
            ...jobFragment
        }
    }
    ${JOB_FRAGMENT}
`;

export const GET_JOB_OFFERS = gql`
    query ($query: String, $filter: JobOfferFilter, $pagination: Pagination, $sortBy: String) {
        getJobOffers(query: $query, filter: $filter, pagination: $pagination, sortBy: $sortBy) {
            docs {
                ...jobFragment
            }
            meta {
                page
                totalPages
                totalDocs
                nextPage
                prevPage
            }
        }
    }
    ${JOB_FRAGMENT}
`;

export const GET_JOB_OFFER_FILTERS = gql`
    query ($query: String, $filter: JobOfferFilter) {
        filters: getJobOfferFilters(query: $query, filter: $filter) {
            sectors {
                _id
                sectorName
                pronounWithSector
            }
            professions {
                groupName
                name
                _id
                specialties {
                    _id
                    name
                    order
                }
            }
            contractTypes
        }
    }
`;

export const SEARCH_JOB_OFFER_FILTERS = gql`
    query ($query: String, $filter: JobOfferFilter) {
        searchJobOfferFilters(query: $query, filter: $filter) {
            sectors {
                value
                label
                count
            }
            professionIds {
                value
                label
                count
                groupLabel
            }
            specialtyIds {
                value
                label
                count
                groupLabel
            }
            contractTypes {
                value
                label
                count
            }
            languageIds {
                value
                label
                count
            }
            cities {
                value
                label
                count
            }
            status {
                value
                label
                count
            }
            proIds {
                value
                label
                count
            }
            brandIds {
                value
                label
                count
            }
            salaryRange {
                min
                max
            }
            workingHoursRange {
                min
                max
            }
            assignees {
                value
                label
                count
                email
                avatarUrl
                assigneeType
            }
            upercutAssignees {
                value
                label
                count
                email
                avatarUrl
                assigneeType
            }
        }
    }
`;

export const GET_FILTER_JOB_OFFER_APPLICATIONS_PRO = gql`
    query ($filter: JobApplicationFilter, $query: String) {
        filters: getFilterJobApplicationsPro(filter: $filter, query: $query) {
            brands {
                _id
                brandName
                logo {
                    _id
                    url
                }
            }
        }
    }
`;

export const GET_FILTER_OPTION_JOB_OFFER_APPLICATIONS = gql`
    query ($filter: JobApplicationFilter, $pagination: Pagination, $sortBy: String, $query: String) {
        getFilterJobOfferApplicationPro(filter: $filter, pagination: $pagination, sortBy: $sortBy, query: $query) {
            title
        }
    }
`;

export const GET_JOB_OFFERS_PRO = gql`
    query ($query: String, $filter: JobOfferFilter, $pagination: Pagination, $sortBy: String) {
        getJobOffersPro(query: $query, filter: $filter, pagination: $pagination, sortBy: $sortBy) {
            docs {
                ...jobFragment
                applications {
                    createdDate
                    talentId
                    status
                    message
                }
            }
            meta {
                page
                totalPages
                totalDocs
                nextPage
                prevPage
            }
            meta {
                page
                totalPages
                totalDocs
                nextPage
                prevPage
            }
        }
    }
    ${JOB_FRAGMENT}
`;

export const GET_JOB_OFFERS_PUBLIC_PRO = gql`
    query ($query: String, $filter: JobOfferFilter, $pagination: Pagination, $sortBy: String) {
        getJobOffersPublicPro(query: $query, filter: $filter, pagination: $pagination, sortBy: $sortBy) {
            docs {
                ...jobFragment
            }
            meta {
                page
                totalPages
                totalDocs
                nextPage
                prevPage
            }
        }
    }
    ${JOB_FRAGMENT}
`;

export const GET_JOB_OFFERS_COUNT_BY_DEPARTMENT = gql`
    query GetJobOffersCountByDepartment {
        getJobOffersCountBasedOnDepartment {
            department
            count
        }
    }
`;

export const GET_SIMILAR_JOB = gql`
    query ($_id: ID, $city: String, $salary: Float, $pagination: Pagination, $sortBy: String) {
        result: getSimilarJobs(_id: $_id, city: $city, salary: $salary, pagination: $pagination, sortBy: $sortBy) {
            docs {
                ...jobFragment
            }
        }
    }
    ${JOB_FRAGMENT}
`;

export const GET_PARTNERS = gql`
    query {
        result: getPartners
    }
`;

export const GET_JOB_OFFER_APPLICATIONS = gql`
    query ($query: String) {
        list: getJobOfferApplications(query: $query) {
            ...jobFragment
        }
    }
    ${JOB_FRAGMENT}
`;

// export const GET_OPTIONS_JOB_OFFER = gql``;

export const GET_AGREGATED_JOB_OFFERS = gql`
    query getJobOffersAggregateByStatus {
        getJobOffersAggregateByStatus {
            _id
            count
        }
    }
`;

export const GET_AGREGATED_JOB_OFFERS_UPERCUT = gql`
    query getJobOffersAggregateByStatusUpercut {
        getJobOffersAggregateByStatusUpercut {
            _id
            count
        }
    }
`;

export const GET_JOB_OFFERS_UPERCUT = gql`
    query GetJobOffersProUpercut($query: String, $filter: JobOfferFilter, $sortBy: String, $pagination: Pagination) {
        getJobOffersUpercut(query: $query, filter: $filter, sortBy: $sortBy, pagination: $pagination) {
            meta {
                # total
                limit
                page
                totalPages
                totalDocs
            }
            docs {
                _id
                title
                city
                postalCode
                address
                jobNumber
                active
                status
                publicLink
                contract {
                    benefits
                    status
                    contractType
                    isAnnualSalary
                    hourPerWeek
                    guaranteedSalary {
                        min
                        max
                        type
                    }
                    remuneration {
                        min
                        max
                    }
                }
                pro {
                    _id
                    name
                    commercialName
                    city
                    fullName
                    bossFirstname
                    bossLastname
                    logo
                }
                createdBy {
                    _id
                    firstName
                    lastName
                    email
                    file {
                        _id
                        url
                    }
                }
                upercutAssignees {
                    _id
                    assignedAt
                    firstName
                    lastName
                    email
                    color
                }
                assignees {
                    _id
                    assigneeType
                    role
                    assignedAt
                    assigneeDetails {
                        ... on OrganizationUser {
                            _id
                            color
                            email
                            firstName
                            lastName
                            role
                            file {
                                _id
                                name
                                url
                            }
                        }
                        ... on Pro {
                            _id
                            email
                            bossFirstname
                            bossLastname
                            bossPhoto
                            commercialName
                            role
                        }
                    }
                }
                jobApplicationsStats {
                    _id
                    count
                }
                views
                brand {
                    brandName
                    brandLogo {
                        _id
                        url
                    }
                }
                recruitment {
                    method
                }
                position {
                    experience
                    companyName
                }
                createdDate
                publishDate
                expiredDate
            }
        }
    }
`;

export const GET_JOB_OFFER_APPLICATION_UPERCUT = gql`
    query GetJobOfferApplicationsUpercut(
        $query: String
        $filter: JobOfferFilter
        $sortBy: JobOfferSortBy
        $pagination: Pagination
        $talentId: String
    ) {
        getJobOfferApplicationsUpercut(
            query: $query
            filter: $filter
            sortBy: $sortBy
            pagination: $pagination
            talentId: $talentId
        ) {
            docs {
                _id
                title
                active
                city
                brand {
                    brandLogo {
                        url
                    }
                }
                contract {
                    status
                    remuneration {
                        min
                        max
                    }
                    rateType
                    isAnnualSalary
                }
                pro {
                    _id
                    name
                    commercialName
                    brandLogo {
                        url
                    }
                }
                application {
                    date
                    status
                    subStatus
                }
                position {
                    experience
                }
                candidate {
                    degree
                }
            }
            meta {
                totalDocs
                limit
                page
                totalPages
                hasPrevPage
                hasNextPage
            }
        }
    }
`;

export const SEND_JOB_INVITATION_UPERCUT = gql`
    mutation SendJobInvitationUpercut($jobNumbers: [String!], $talentIds: [ID!]) {
        sendInvitationJobOfferUpercut(jobNumbers: $jobNumbers, talentIds: $talentIds)
    }
`;

export const DEACTIVATE_JOB_OFFER = gql`
    mutation DeactivateJobOfferStatusUpercut($id: ID!) {
        deactivateJobOfferStatusUpercut(_id: $id) {
            _id
            active
            title
            jobNumber
            city
            postalCode
            address
            publishDate
            enablePublishDate
            createdDate
        }
    }
`;

export const GET_JOB_APPLICATIONS_STATS = gql`
    query GetJobApplicationsStats {
        getJobApplicationsStats {
            new
            interview
            trial
            offer
            probationPeriod
            hired
            rejected
        }
    }
`;

export const GET_JOB_OFFER_APPLICATION_STATS = gql`
    query GetJobOfferApplicationStats($jobNumber: String!, $proId: ID) {
        getJobOfferApplicationStats(jobNumber: $jobNumber, proId: $proId) {
            views
            applicationsByStatus {
                status
                count
                subStatuses {
                    subStatus
                    count
                }
            }
            applicationsBySource {
                source
                count
            }
        }
    }
`;

export const GET_JOB_APPLICATIONS_PRO_V2 = gql`
    query GetJobApplicationsProV2(
        $query: String
        $filter: JobApplicationFilter
        $sortBy: JobApplicationSortBy
        $pagination: Pagination
    ) {
        getJobApplicationsProV2(query: $query, filter: $filter, sortBy: $sortBy, pagination: $pagination) {
            docs {
                _id
                status
                subStatus
                premiumStatus
                premiumSubStatus
                recruitmentMethod
                staleness {
                    level
                }
                date
                type
                rating
                resumeScore
                resumeScoreError
                resumeExplainer
                scoringStatus
                upercutAverageRating
                upercutRatings {
                    upercutId
                    rating
                    createdAt
                }
                upercutNotes {
                    _id
                    upercutId
                    title
                    note
                    visibility
                    createdAt
                }
                jobOffer {
                    _id
                    title
                    city
                    active
                    contract {
                        status
                        remuneration {
                            min
                            max
                        }
                        rateType
                        isAnnualSalary
                    }
                    position {
                        experience
                    }
                    candidate {
                        degree
                    }
                    brand {
                        brandName
                        brandLogo {
                            url
                        }
                    }
                    pro {
                        _id
                        name
                        commercialName
                        brandLogo {
                            url
                        }
                    }
                }
                talent {
                    _id
                    firstName
                    lastName
                    email
                    phoneNumber
                    photo
                    logo
                    active
                    city
                    degree
                    yearsOfExperience
                    currentStatusUser
                    resumeId
                    upercutFavorites {
                        _id
                        type
                        upercutId
                        createdAt
                    }
                    principalProfession {
                        _id
                        professionName
                    }
                    experiences {
                        _id
                        title
                        enterprise {
                            name
                        }
                        startDate
                        endDate
                    }
                }
            }
            meta {
                totalDocs
                limit
                page
                totalPages
                hasPrevPage
                hasNextPage
            }
        }
    }
`;

export const GET_JOB_APPLICATIONS_UPERCUT = gql`
    query GetJobApplicationsUpercut(
        $query: String
        $filter: JobApplicationFilter
        $sortBy: JobApplicationSortBy
        $pagination: Pagination
    ) {
        getJobApplicationsUpercut(query: $query, filter: $filter, sortBy: $sortBy, pagination: $pagination) {
            docs {
                _id
                status
                subStatus
                premiumStatus
                premiumSubStatus
                recruitmentMethod
                staleness {
                    level
                }
                date
                type
                rating
                resumeScore
                resumeScoreError
                resumeExplainer
                scoringStatus
                reference
                upercutAverageRating
                upercutRatings {
                    upercutId
                    rating
                    createdAt
                }
                upercutNotes {
                    _id
                    upercutId
                    title
                    note
                    visibility
                    createdAt
                }
                jobOffer {
                    _id
                    jobNumber
                    title
                    city
                    active
                    contract {
                        status
                        remuneration {
                            min
                            max
                        }
                        rateType
                        isAnnualSalary
                    }
                    position {
                        experience
                    }
                    candidate {
                        degree
                    }
                    brand {
                        brandName
                        brandLogo {
                            url
                        }
                    }
                    pro {
                        _id
                        name
                        commercialName
                        brandLogo {
                            url
                        }
                    }
                }
                talent {
                    _id
                    firstName
                    lastName
                    email
                    phoneNumber
                    photo
                    logo
                    active
                    city
                    degree
                    yearsOfExperience
                    currentStatusUser
                    resumeId
                    upercutFavorites {
                        _id
                        type
                        upercutId
                        createdAt
                    }
                    principalProfession {
                        _id
                        professionName
                    }
                    experiences {
                        _id
                        title
                        enterprise {
                            name
                        }
                        startDate
                        endDate
                    }
                }
            }
            meta {
                totalDocs
                limit
                page
                totalPages
                hasPrevPage
                hasNextPage
            }
        }
    }
`;

export const SEARCH_JOB_APPLICATIONS_PRO = gql`
    query SearchJobApplicationsPro(
        $query: String
        $filter: JobApplicationFilter
        $sortBy: JobApplicationSortBy
        $pagination: Pagination
    ) {
        searchJobApplicationsPro(query: $query, filter: $filter, sortBy: $sortBy, pagination: $pagination) {
            docs {
                _id
                jobApplicationNumber
                status
                subStatus
                premiumStatus
                premiumSubStatus
                recruitmentMethod
                staleness {
                    level
                }
                date
                type
                rating
                resumeScore
                resumeExplainer
                scoringStatus
                upercutAverageRating
                upercutRatings {
                    upercutId
                    rating
                    createdAt
                }
                upercutNotes {
                    _id
                    upercutId
                    title
                    note
                    visibility
                    createdAt
                }
                jobOffer {
                    _id
                    title
                    city
                    active
                    contract {
                        status
                        remuneration {
                            min
                            max
                        }
                        rateType
                        isAnnualSalary
                    }
                    position {
                        experience
                    }
                    candidate {
                        degree
                    }
                    brand {
                        brandName
                        brandLogo {
                            url
                        }
                    }
                    pro {
                        _id
                        name
                        commercialName
                        brandLogo {
                            url
                        }
                    }
                }
                talent {
                    _id
                    firstName
                    lastName
                    email
                    photo
                    logo
                    active
                    city
                    degree
                    yearsOfExperience
                    resumeId
                    currentStatusUser
                    upercutFavorites {
                        _id
                        type
                        upercutId
                        createdAt
                    }
                    principalProfession {
                        _id
                        professionName
                    }
                    experiences {
                        _id
                        title
                        enterprise {
                            name
                        }
                        startDate
                        endDate
                    }
                    resume {
                        path
                    }
                }
            }
            meta {
                totalDocs
                limit
                page
                totalPages
                hasPrevPage
                hasNextPage
            }
        }
    }
`;

export const SEARCH_JOB_APPLICATIONS_UPERCUT = gql`
    query SearchJobApplicationsUpercut(
        $query: String
        $filter: JobApplicationFilter
        $sortBy: JobApplicationSortBy
        $pagination: Pagination
    ) {
        searchJobApplicationsUpercut(query: $query, filter: $filter, sortBy: $sortBy, pagination: $pagination) {
            docs {
                _id
                jobApplicationNumber
                status
                subStatus
                premiumStatus
                premiumSubStatus
                recruitmentMethod
                staleness {
                    level
                }
                date
                type
                rating
                resumeScore
                resumeScoreError
                resumeExplainer
                scoringStatus
                reference
                upercutAverageRating
                upercutRatings {
                    upercutId
                    rating
                    createdAt
                }
                upercutNotes {
                    _id
                    upercutId
                    title
                    note
                    visibility
                    createdAt
                }
                jobOffer {
                    _id
                    jobNumber
                    title
                    city
                    active
                    contract {
                        status
                        remuneration {
                            min
                            max
                        }
                        rateType
                        isAnnualSalary
                    }
                    position {
                        experience
                    }
                    candidate {
                        degree
                    }
                    brand {
                        brandName
                        brandLogo {
                            url
                        }
                    }
                    pro {
                        _id
                        name
                        commercialName
                        brandLogo {
                            url
                        }
                    }
                }
                talent {
                    _id
                    firstName
                    lastName
                    email
                    photo
                    logo
                    active
                    city
                    degree
                    yearsOfExperience
                    resumeId
                    currentStatusUser
                    upercutFavorites {
                        _id
                        type
                        upercutId
                        createdAt
                    }
                    principalProfession {
                        _id
                        professionName
                    }
                    experiences {
                        _id
                        title
                        enterprise {
                            name
                        }
                        startDate
                        endDate
                    }
                    resume {
                        path
                    }
                }
            }
            meta {
                totalDocs
                limit
                page
                totalPages
                hasPrevPage
                hasNextPage
            }
        }
    }
`;

export const GET_ASSIGNABLE_USERS = gql`
    query getAssignableUsers($query: String, $pagination: Pagination, $assigneeTypes: [AssigneeType!]) {
        getAssignableUsers(query: $query, pagination: $pagination, assigneeTypes: $assigneeTypes) {
            docs {
                _id
                assigneeType
                assigneeDetails {
                    ... on OrganizationUser {
                        _id
                        color
                        email
                        firstName
                        lastName
                        role
                        higherUpId
                        file {
                            _id
                            name
                            url
                        }
                    }
                    ... on Pro {
                        _id
                        email
                        bossFirstname
                        bossLastname
                        bossPhoto
                        commercialName
                        role
                    }
                }
            }
            meta {
                totalDocs
                limit
                page
                nextPage
                prevPage
                totalPages
                hasPrevPage
                hasNextPage
                pagingCounter
            }
        }
    }
`;

export const GET_ASSIGNABLE_USERS_UPERCUT = gql`
    query getAssignableUsersUpercut(
        $proId: ID!
        $query: String
        $pagination: Pagination
        $assigneeTypes: [AssigneeType!]
    ) {
        getAssignableUsersUpercut(
            proId: $proId
            query: $query
            pagination: $pagination
            assigneeTypes: $assigneeTypes
        ) {
            docs {
                _id
                assigneeType
                assigneeDetails {
                    ... on OrganizationUser {
                        _id
                        color
                        email
                        firstName
                        lastName
                        role
                        higherUpId
                        file {
                            _id
                            name
                            url
                        }
                    }
                    ... on Pro {
                        _id
                        email
                        bossFirstname
                        bossLastname
                        bossPhoto
                        commercialName
                        role
                    }
                }
            }
            meta {
                totalDocs
                limit
                page
                nextPage
                prevPage
                totalPages
                hasPrevPage
                hasNextPage
                pagingCounter
            }
        }
    }
`;

const JOB_APPLICATION_FILTER_FIELDS = `
    proIds { value label count }
    statuses { value label count }
    cities { value label count }
    jobOfferCities { value label count }
    specialties { value label count groupLabel }
    diplomaTypes { value label count }
    contractTypes { value label count }
    professions { value label count groupLabel }
    sectorIds { value label count }
    upercutAssigneeIds { value label count }
    experienceRange { min max }
    salaryRange { min max }
    resumeScoreRange { min max }
`;

export const SEARCH_JOB_APPLICATION_FILTERS_PRO = gql`
    query SearchJobApplicationFiltersPro($filter: JobApplicationFilter, $query: String) {
        searchJobApplicationFiltersPro(filter: $filter, query: $query) {
            ${JOB_APPLICATION_FILTER_FIELDS}
        }
    }
`;

export const SEARCH_JOB_APPLICATION_FILTERS_UPERCUT = gql`
    query SearchJobApplicationFiltersUpercut($filter: JobApplicationFilter, $query: String) {
        searchJobApplicationFiltersUpercut(filter: $filter, query: $query) {
            ${JOB_APPLICATION_FILTER_FIELDS}
        }
    }
`;

export const GET_JOB_APPLICATION_DETAIL = gql`
    query GetJobApplicationDetail($id: ID!) {
        getJobApplication(id: $id) {
            _id
            status
            subStatus
            premiumStatus
            premiumSubStatus
            recruitmentMethod
            staleness {
                level
                lastUpdateDate
                daysSinceUpdate
            }
            interviewScheduledAt
            zohoBookingId
            zohoBookingUrl
            sentToClientAt
            sentToClientBy
            questionnaireId
            questionnaireSentAt
            date
            reference
            jobApplicationNumber
            resumeFile {
                _id
                url
                name
            }
            resume
            type
            rating
            resumeScore
            scoringStatus
            upercutAverageRating
            upercutRatings {
                upercutId
                rating
                createdAt
            }
            upercutNotes {
                _id
                upercutId
                title
                note
                visibility
                createdAt
            }
            talent {
                _id
                firstName
                lastName
                email
                phoneNumber
                photo
                logo
                city
                yearsOfExperience
                currentStatusUser
                resume {
                    path
                    name
                    mimetype
                }
                principalProfession {
                    _id
                    professionName
                }
                experiences {
                    _id
                    title
                    enterprise {
                        name
                    }
                    startDate
                    endDate
                }
                files {
                    _id
                    name
                    path
                    context
                    size
                    url
                    mimetype
                }
                upercutFavorites {
                    _id
                    type
                    upercutId
                    createdAt
                }
            }
            pro {
                _id
                name
                commercialName
                city
                brandLogo {
                    url
                }
            }
            jobOffer {
                _id
                title
                city
                jobNumber
                active
                contract {
                    contractType
                    remuneration {
                        min
                        max
                    }
                    isAnnualSalary
                    showSalary
                }
                recruitment {
                    method
                }
                brand {
                    _id
                    brandName
                    brandLogo {
                        url
                    }
                }
            }
        }
    }
`;

export const ASSIGN_UPERCUT_TO_JOB_OFFER = gql`
    mutation ($jobOfferId: ID!, $upercutIds: [ID!]!) {
        assignUpercutToJobOffer(jobOfferId: $jobOfferId, upercutIds: $upercutIds) {
            _id
            upercutAssignees {
                _id
                assignedAt
                firstName
                lastName
                email
                color
            }
        }
    }
`;

export const REMOVE_UPERCUT_FROM_JOB_OFFER = gql`
    mutation ($jobOfferId: ID!, $upercutIds: [ID!]!) {
        removeUpercutFromJobOffer(jobOfferId: $jobOfferId, upercutIds: $upercutIds) {
            _id
            upercutAssignees {
                _id
                assignedAt
                firstName
                lastName
                email
                color
            }
        }
    }
`;

export const GET_JOB_APPLICATION_LOGS = gql`
    query GetJobApplicationLogs($jobApplicationId: ID!, $limit: Int) {
        getJobApplicationLogs(jobApplicationId: $jobApplicationId, limit: $limit) {
            _id
            userId
            roleUser
            before
            after
            premiumBefore
            premiumAfter
            event
            createdDate
        }
    }
`;

export const GET_JOB_APPLICATION_STALENESS = gql`
    query GetJobApplicationStaleness($jobApplicationId: ID!) {
        getJobApplicationStaleness(jobApplicationId: $jobApplicationId) {
            level
            lastUpdateDate
            daysSinceUpdate
        }
    }
`;
